var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatures4Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9998 30.9005V16.8205C55.9999 16.1809 55.8083 15.5558 55.4498 15.0261C55.0912 14.4964 54.582 14.0863 53.9881 13.8488L41.1882 8.7288C40.4254 8.42373 39.5744 8.42373 38.8116 8.7288L25.1882 14.1795C24.4254 14.4845 23.5745 14.4845 22.8117 14.1795L10.1952 9.132C9.95178 9.03444 9.6881 8.99821 9.42738 9.0265C9.16666 9.0548 8.91689 9.14674 8.70006 9.29425C8.48322 9.44176 8.30597 9.64031 8.1839 9.87242C8.06183 10.1045 7.99868 10.3631 8.00002 10.6253V41.2877C7.99991 41.9274 8.19152 42.5524 8.55011 43.0822C8.9087 43.6119 9.41781 44.0219 10.0117 44.2595L22.8117 49.3795C23.5745 49.6846 24.4254 49.6846 25.1882 49.3795",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.4082V30.901",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8.5V22.9",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.9985 56.5004L49.5687 50.0705M52.7984 42.1004C52.7984 48.286 47.784 53.3004 41.5984 53.3004C35.4128 53.3004 30.3984 48.286 30.3984 42.1004C30.3984 35.9148 35.4128 30.9004 41.5984 30.9004C47.784 30.9004 52.7984 35.9148 52.7984 42.1004Z",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures4Svg);
export default __webpack_public_path__ + "static/media/features4SVG.180460f58ea476364a38e25693180856.svg";
export { ForwardRef as ReactComponent };